import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { salesServiceOrderService } from '../../../services/salesServiceOrderService';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';
import Toast from '../../../components/Common/Toast';
import SalesQuoteProgressBar from '../../../components/Ventas/SalesQuoteProgressBar';
import { getSalesQuoteFulfillmentLabel } from '../../../utils/salesQuoteProgress';

const EditVentasServiceOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await salesServiceOrderService.getServiceOrder(id);
        if (res.success) setOrder(res.data);
        else navigate('/ventas/service-orders', { state: { posConfirmed: true } });
      } catch {
        navigate('/ventas/service-orders', { state: { posConfirmed: true } });
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id, navigate]);

  if (loading) {
    return <div className="p-6 text-center text-gray-500">Cargando...</div>;
  }

  const readOnly = order?.status === 'cancelled';
  const status = order ? getSalesQuoteFulfillmentLabel(order) : null;

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            {readOnly ? 'Ver orden de servicio' : 'Editar orden de servicio'}
          </h1>
          <p className="text-sm font-mono text-teal-600 mt-1">{order?.code}</p>
          {order?.sales_quote?.code ? (
            <p className="text-sm text-gray-600 mt-1">Cotización: {order.sales_quote.code}</p>
          ) : null}
          {order && (
            <div className="mt-3 flex flex-wrap items-center gap-3">
              <SalesQuoteProgressBar quote={order} className="w-48" barClassName="h-2.5" />
              {status ? (
                <span className={`px-2 py-1 text-xs rounded-full ${status.className}`}>{status.label}</span>
              ) : null}
            </div>
          )}
        </div>
        <VentasCommercialForm
          mode="service_order"
          entity={order}
          readOnly={readOnly}
          isPageMode
          onClose={() => navigate('/ventas/service-orders', { state: { posConfirmed: true } })}
          onSuccess={() => navigate('/ventas/service-orders', { state: { posConfirmed: true } })}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditVentasServiceOrder;
